import React, { useContext } from 'react';
import Slider from 'react-slick';
import { ASSubpageEnum, OverlayEnum } from '../../../enums';
import { setASSubpage, setOverlay } from '../../../utils/SspProvider/dispatchFunctions';
import SspProviderContext from '../../../utils/SspProvider/context';
import { DataNode } from '../../../utils/PickUpTypes';
import { SET_DETAILS_NODE } from '../../../utils/SspProvider/store';
import i18next from 'i18next';

interface SliderTileProps {
    headline: string;
    tiles: { image: string; title: string; subline: string; onClick: ASSubpageEnum; node?: DataNode }[];
    id?: string;
}

function SliderTile({ headline, tiles, id }: SliderTileProps) {
    const settings = {
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        arrows: true,
        centerMode: false,
        dots: true,
    };

    const store = useContext(SspProviderContext);

    return (
        <article className='slider-tile' id={id}>
            <h2>{headline}</h2>
            <div className='carousel-wrapper'>
                <Slider {...settings}>
                    {tiles.map((tile, i) => (
                        <div
                            key={i}
                            className='slide-item'
                            onClick={() => {
                                //custom logic for last tile as client wanted the last tile to link their own website for further information
                                const isLastItem = i === tiles.length - 1;

                                if (isLastItem && headline === i18next.t('MoreAttractions')) {
                                    setOverlay(store, {
                                        enum: OverlayEnum.ExternalContent,
                                        media: 'https://www.autostadt.de/auf-einen-blick',
                                    });
                                } else {
                                    setASSubpage(store, {
                                        asEnum: tile.onClick,
                                    });
                                }
                                if (tile.node) store.dispatch({ type: SET_DETAILS_NODE, value: tile.node });
                            }}
                        >
                            <img src={tile.image} alt='' />
                            <h3>{tile.title}</h3>
                            <p className='body large'>
                                {tile.subline}
                                <svg className='icon-24'>
                                    <use xlinkHref='#as-arrow-right'></use>{' '}
                                </svg>
                            </p>
                        </div>
                    ))}
                </Slider>
            </div>
        </article>
    );
}

export default SliderTile;
